import { render, staticRenderFns } from "./SpecificsEn.vue?vue&type=template&id=2de34625&scoped=true&"
import script from "./SpecificsEn.vue?vue&type=script&lang=js&"
export * from "./SpecificsEn.vue?vue&type=script&lang=js&"
import style0 from "./SpecificsEn.vue?vue&type=style&index=0&id=2de34625&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de34625",
  null
  
)

export default component.exports